<template>
  <div id="health" :class="cls">
    <h2>{{ this.message(this.$appdata.messages, "health").label }}</h2>
    <b-row class="justify-content-center">
      <b-form-radio-group
        v-model="value"
        :options="options"
        ref="health_bracket"
        stacked
        class="mb-3 text-left"
        @keyup.native="adv"
      ></b-form-radio-group>
    </b-row>
  </div>
</template>
<script>
import { required, between } from "vuelidate/lib/validators";
import { compStyles } from "@/mixins/compStyles";
import { messaging } from "@/mixins/messaging";
import { navigation } from "@/mixins/navigation";
export default {
  props: ["active_key", "active_index", "issues", "health_bracket"],
  mixins: [messaging, compStyles, navigation],
  data() {
    return {
      disp_key: 2,
      value: "1",
      cls: "component out",
      options: [
        { value: 1, text: "Healthy/Average" },
        { value: 2, text: "Minor Impairment(s)" },
        { value: 3, text: "Major Impairment(s)" },
        { value: 4, text: "Terminal Illness" },
      ],
    };
  },
  validations: {
    value: {
      required,
      between: between(1, 4),
    },
  },
  methods: {
    setProp: function () {
      if (!this.$v.value.$invalid) {
        this.$emit("setProp", { prop: "health_bracket", value: this.value });
        this.$emit("setProp", {
          prop: "health_bracket_str",
          value: this.health_bracket_str,
        });

        this.$emit("setProp", { prop: "nextDisabled", value: false });
      } else {
        this.$emit("setProp", { prop: "health_bracket", value: this.value });
        this.$emit("setProp", {
          prop: "health_bracket_str",
          value: this.health_bracket_str,
        });
        this.$emit("setProp", { prop: "nextDisabled", value: "disabled" });
      }
      return;
    },
    adv: function (event) {
      if (event.key == "Enter" && !this.$v.value.$invalid) {
        this.incNext();
      }
    },
  },
  computed: {
    health_bracket_str: function () {
      var str;
      this.options.forEach((item) => {
        if (item.value == this.value) {
          str = item.text;
        }
      });
      return str;
    },
  },
  watch: {
    cls: function () {
      var t = this;
      setTimeout(function () {
        if (t.value < 1) {
          t.$emit("setProp", { prop: "nextDisabled", value: "disabled" });
        }
      }, 200);
    },
    value: function () {
      this.setProp();
    },
    active_key: function (n) {
      this.toggleActive(n);
      if (n == this.disp_key && !this.$v.value.$invalid) {
        this.$emit("setProp", { prop: "nextDisabled", value: false });
      } else {
        this.$emit("setProp", { prop: "nextDisabled", value: "disabled" });
      }
    },
  },
};
</script>
